// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file cadendar/stickies/v1/stickies.proto (package cadendar.stickies.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cadendar/stickies/v1/stickies.proto.
 */
export const file_cadendar_stickies_v1_stickies: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message cadendar.stickies.v1.GetStickiesRequest
 */
export type GetStickiesRequest = Message<"cadendar.stickies.v1.GetStickiesRequest"> & {
  /**
   * @generated from field: string owner_id = 1;
   */
  ownerId: string;

  /**
   * @generated from field: int32 year = 2;
   */
  year: number;

  /**
   * @generated from field: int32 week = 3;
   */
  week: number;
};

/**
 * Describes the message cadendar.stickies.v1.GetStickiesRequest.
 * Use `create(GetStickiesRequestSchema)` to create a new message.
 */
export const GetStickiesRequestSchema: GenMessage<GetStickiesRequest> = /*@__PURE__*/
  messageDesc(file_cadendar_stickies_v1_stickies, 0);

/**
 * @generated from message cadendar.stickies.v1.GetStickiesResponse
 */
export type GetStickiesResponse = Message<"cadendar.stickies.v1.GetStickiesResponse"> & {
  /**
   * @generated from field: repeated cadendar.stickies.v1.Sticky stickies = 1;
   */
  stickies: Sticky[];
};

/**
 * Describes the message cadendar.stickies.v1.GetStickiesResponse.
 * Use `create(GetStickiesResponseSchema)` to create a new message.
 */
export const GetStickiesResponseSchema: GenMessage<GetStickiesResponse> = /*@__PURE__*/
  messageDesc(file_cadendar_stickies_v1_stickies, 1);

/**
 * @generated from message cadendar.stickies.v1.CreateStickyRequest
 */
export type CreateStickyRequest = Message<"cadendar.stickies.v1.CreateStickyRequest"> & {
  /**
   * @generated from field: string owner_id = 1;
   */
  ownerId: string;

  /**
   * @generated from field: cadendar.stickies.v1.StickyInput sticky = 2;
   */
  sticky?: StickyInput | undefined;
};

/**
 * Describes the message cadendar.stickies.v1.CreateStickyRequest.
 * Use `create(CreateStickyRequestSchema)` to create a new message.
 */
export const CreateStickyRequestSchema: GenMessage<CreateStickyRequest> = /*@__PURE__*/
  messageDesc(file_cadendar_stickies_v1_stickies, 2);

/**
 * @generated from message cadendar.stickies.v1.CreateStickyResponse
 */
export type CreateStickyResponse = Message<"cadendar.stickies.v1.CreateStickyResponse"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message cadendar.stickies.v1.CreateStickyResponse.
 * Use `create(CreateStickyResponseSchema)` to create a new message.
 */
export const CreateStickyResponseSchema: GenMessage<CreateStickyResponse> = /*@__PURE__*/
  messageDesc(file_cadendar_stickies_v1_stickies, 3);

/**
 * @generated from message cadendar.stickies.v1.UpdateStickyRequest
 */
export type UpdateStickyRequest = Message<"cadendar.stickies.v1.UpdateStickyRequest"> & {
  /**
   * @generated from field: string owner_id = 1;
   */
  ownerId: string;

  /**
   * @generated from field: int32 id = 2;
   */
  id: number;

  /**
   * @generated from field: cadendar.stickies.v1.StickyUpdate sticky = 3;
   */
  sticky?: StickyUpdate | undefined;
};

/**
 * Describes the message cadendar.stickies.v1.UpdateStickyRequest.
 * Use `create(UpdateStickyRequestSchema)` to create a new message.
 */
export const UpdateStickyRequestSchema: GenMessage<UpdateStickyRequest> = /*@__PURE__*/
  messageDesc(file_cadendar_stickies_v1_stickies, 4);

/**
 * @generated from message cadendar.stickies.v1.UpdateStickyResponse
 */
export type UpdateStickyResponse = Message<"cadendar.stickies.v1.UpdateStickyResponse"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message cadendar.stickies.v1.UpdateStickyResponse.
 * Use `create(UpdateStickyResponseSchema)` to create a new message.
 */
export const UpdateStickyResponseSchema: GenMessage<UpdateStickyResponse> = /*@__PURE__*/
  messageDesc(file_cadendar_stickies_v1_stickies, 5);

/**
 * @generated from message cadendar.stickies.v1.ArchiveStickyRequest
 */
export type ArchiveStickyRequest = Message<"cadendar.stickies.v1.ArchiveStickyRequest"> & {
  /**
   * @generated from field: string owner_id = 1;
   */
  ownerId: string;

  /**
   * @generated from field: int32 id = 2;
   */
  id: number;
};

/**
 * Describes the message cadendar.stickies.v1.ArchiveStickyRequest.
 * Use `create(ArchiveStickyRequestSchema)` to create a new message.
 */
export const ArchiveStickyRequestSchema: GenMessage<ArchiveStickyRequest> = /*@__PURE__*/
  messageDesc(file_cadendar_stickies_v1_stickies, 6);

/**
 * @generated from message cadendar.stickies.v1.ArchiveStickyResponse
 */
export type ArchiveStickyResponse = Message<"cadendar.stickies.v1.ArchiveStickyResponse"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message cadendar.stickies.v1.ArchiveStickyResponse.
 * Use `create(ArchiveStickyResponseSchema)` to create a new message.
 */
export const ArchiveStickyResponseSchema: GenMessage<ArchiveStickyResponse> = /*@__PURE__*/
  messageDesc(file_cadendar_stickies_v1_stickies, 7);

/**
 * @generated from message cadendar.stickies.v1.Sticky
 */
export type Sticky = Message<"cadendar.stickies.v1.Sticky"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * @generated from field: int32 offset_x = 3;
   */
  offsetX: number;

  /**
   * @generated from field: int32 offset_y = 4;
   */
  offsetY: number;

  /**
   * @generated from field: int32 year = 5;
   */
  year: number;

  /**
   * @generated from field: int32 week = 6;
   */
  week: number;

  /**
   * @generated from field: string anchor_id = 7;
   */
  anchorId: string;

  /**
   * @generated from field: string position_mode = 8;
   */
  positionMode: string;

  /**
   * @generated from field: optional double relative_x = 9;
   */
  relativeX?: number | undefined;

  /**
   * @generated from field: optional double relative_y = 10;
   */
  relativeY?: number | undefined;

  /**
   * @generated from field: optional string doctor_creator = 11;
   */
  doctorCreator?: string | undefined;

  /**
   * @generated from field: optional string secretary_creator = 12;
   */
  secretaryCreator?: string | undefined;
};

/**
 * Describes the message cadendar.stickies.v1.Sticky.
 * Use `create(StickySchema)` to create a new message.
 */
export const StickySchema: GenMessage<Sticky> = /*@__PURE__*/
  messageDesc(file_cadendar_stickies_v1_stickies, 8);

/**
 * @generated from message cadendar.stickies.v1.StickyInput
 */
export type StickyInput = Message<"cadendar.stickies.v1.StickyInput"> & {
  /**
   * @generated from field: string content = 1;
   */
  content: string;

  /**
   * @generated from field: int32 year = 2;
   */
  year: number;

  /**
   * @generated from field: int32 week = 3;
   */
  week: number;

  /**
   * @generated from field: int32 offset_x = 4;
   */
  offsetX: number;

  /**
   * @generated from field: int32 offset_y = 5;
   */
  offsetY: number;

  /**
   * @generated from field: string anchor_id = 6;
   */
  anchorId: string;

  /**
   * @generated from field: string position_mode = 7;
   */
  positionMode: string;

  /**
   * @generated from field: optional double relative_x = 8;
   */
  relativeX?: number | undefined;

  /**
   * @generated from field: optional double relative_y = 9;
   */
  relativeY?: number | undefined;
};

/**
 * Describes the message cadendar.stickies.v1.StickyInput.
 * Use `create(StickyInputSchema)` to create a new message.
 */
export const StickyInputSchema: GenMessage<StickyInput> = /*@__PURE__*/
  messageDesc(file_cadendar_stickies_v1_stickies, 9);

/**
 * @generated from message cadendar.stickies.v1.StickyUpdate
 */
export type StickyUpdate = Message<"cadendar.stickies.v1.StickyUpdate"> & {
  /**
   * @generated from field: string content = 1;
   */
  content: string;

  /**
   * @generated from field: int32 offset_x = 2;
   */
  offsetX: number;

  /**
   * @generated from field: int32 offset_y = 3;
   */
  offsetY: number;

  /**
   * @generated from field: string anchor_id = 4;
   */
  anchorId: string;

  /**
   * @generated from field: string position_mode = 5;
   */
  positionMode: string;

  /**
   * @generated from field: optional double relative_x = 6;
   */
  relativeX?: number | undefined;

  /**
   * @generated from field: optional double relative_y = 7;
   */
  relativeY?: number | undefined;
};

/**
 * Describes the message cadendar.stickies.v1.StickyUpdate.
 * Use `create(StickyUpdateSchema)` to create a new message.
 */
export const StickyUpdateSchema: GenMessage<StickyUpdate> = /*@__PURE__*/
  messageDesc(file_cadendar_stickies_v1_stickies, 10);

/**
 * @generated from service cadendar.stickies.v1.StickiesService
 */
export const StickiesService: GenService<{
  /**
   * @generated from rpc cadendar.stickies.v1.StickiesService.GetStickies
   */
  getStickies: {
    methodKind: "unary";
    input: typeof GetStickiesRequestSchema;
    output: typeof GetStickiesResponseSchema;
  },
  /**
   * @generated from rpc cadendar.stickies.v1.StickiesService.CreateSticky
   */
  createSticky: {
    methodKind: "unary";
    input: typeof CreateStickyRequestSchema;
    output: typeof CreateStickyResponseSchema;
  },
  /**
   * @generated from rpc cadendar.stickies.v1.StickiesService.UpdateSticky
   */
  updateSticky: {
    methodKind: "unary";
    input: typeof UpdateStickyRequestSchema;
    output: typeof UpdateStickyResponseSchema;
  },
  /**
   * @generated from rpc cadendar.stickies.v1.StickiesService.ArchiveSticky
   */
  archiveSticky: {
    methodKind: "unary";
    input: typeof ArchiveStickyRequestSchema;
    output: typeof ArchiveStickyResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_cadendar_stickies_v1_stickies, 0);

